module.exports = __webpack_public_path__ + "static/media/walkthroughMagicLink.060e1f3a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/guestlist/walkthroughMagicLink.mp4
// module id = 2362
// module chunks = 71